import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ExceptionService } from '../../core';
import { API } from '../../shared/constants';
import { News } from './news.model';
import { HttpClientService } from '../../shared/http.client.service';

let newsUrl = API.ENDPOINT.NEWS;

@Injectable()
export class NewsService {
  private headers = new Headers({'Content-Type': 'application/json'});

  constructor(
    private _httpClientService: HttpClientService,
    private exceptionService: ExceptionService
  ) { }

  getNews(id: string) {
    return <Observable<News>>this._httpClientService
      .get(`${newsUrl}${id}`)
      .map((response) => {
        let data = this.extractData<any>(response);
        return <News[]>data.news;
      })
      .catch(this.exceptionService.catchBadResponse)
      .finally(() => {});
  }

  addNews() {
    let body = '';

    return <Observable<News>>this._httpClientService
      .post(`${newsUrl}persist`, body)
      .map((response) => {
        let data = this.extractData<any>(response);
        return <News>data.news;
      })
      .catch(this.exceptionService.catchBadResponse)
      .finally(() => {});
  }

  updateNews(news: any) {
    return this._httpClientService
      .put(API.ENDPOINT.NEWS+'persist', JSON.stringify(news), this.headers)
      .toPromise()
      .then(res => res.json())
      .catch(this.exceptionService.catchBadResponse);
  }

  getNewsById(id: any) {
    return this._httpClientService
      .get(API.ENDPOINT.NEWS + id)
      .toPromise()
      .then(response => response.json().news)
      .catch(this.exceptionService.catchBadResponse);
  }

  deleteNews(id: any) {
    return this._httpClientService
      .delete(API.ENDPOINT.NEWS +'delete/'+id)
      .toPromise()
      .then(res => res.json())
      .catch(this.exceptionService.catchBadResponse);
  }

  private extractData<T>(res: Response) {
    if (res.status < 200 ||
        res.status >= 300) {
      throw new Error('Bad response status: ' + res.status);
    }
    let body = res.json ? res.json() : null;
    return <T>(body || {});
  }
}



// WEBPACK FOOTER //
// ./src/app/noticias/shared/news.service.ts